import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CardActionArea from "@material-ui/core/CardActionArea";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import red from "@material-ui/core/colors/red";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import WarningOutlined from "@material-ui/icons/WarningOutlined";
import AccountBalanceWalletOutlined from "@material-ui/icons/AccountBalanceWalletOutlined";
import AccessTimeOutlined from "@material-ui/icons/AccessTimeOutlined";
import CancelTest from "./Dialogs/CancelTest";

const styles = theme => ({
  card: {
    maxWidth: "100%",
    marginBottom: 15
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8
    }
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  leftIcon: {
    marginRight: theme.spacing.unit * 0.5
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  buttonDanger: {
    color: "#DD1B22",
    textTransform: "initial"
  },
  durationOverImageContainer: {
    position: "absolute",
    right: 15,
    top: 15,
    color: "#fff"
  }
});

class TestItemOngoing extends React.PureComponent {
  state = {
    anchorEl: null,
    cancel: false
  };

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleTestCancel = () => {
    this.setState({
      anchorEl: null,
      cancel: true
    });
  };

  render() {
    const { anchorEl } = this.state;
    const {
      classes,
      testImage,
      test,
      test: { project }
    } = this.props;
    const open = Boolean(anchorEl);
    console.log("TestItemOngoing", test);

    return (
      <Card className={classes.card} elevation={6}>
        <CardActionArea
          style={{ width: "100%" }}
          component={Link}
          to={`/test/${test.id}/ongoing`}
        >
          <CardMedia
            className={classes.media}
            image={testImage}
            title="Contemplative Reptile"
          >
            {/*<div className={classes.durationOverImageContainer}>*/}
            {/*  <Typography*/}
            {/*    style={{ color: "#fff", fontWeight: 300, fontSize: 20 }}*/}
            {/*  >*/}
            {/*    <strong>1</strong> / 30 dias*/}
            {/*  </Typography>*/}
            {/*</div>*/}
          </CardMedia>
        </CardActionArea>
        <CardHeader
          action={
            <IconButton>
              <MoreVertIcon onClick={this.handleMenuClick} />
            </IconButton>
          }
          title={project.project_type.name}
          subheader={`№ estudio: ${test.id}`}
        />

        {/*<CardActionArea*/}
        {/*  style={{ width: "100%" }}*/}
        {/*  component={Link}*/}
        {/*  to={`/test/${test.id}/detail`}*/}
        {/*>*/}
        {/*  <CardContent>*/}
        {/*    <Typography component="p">*/}
        {/*      /!*Tuvo celebrará sancionadora tribunal protocolo, como había existe al cambios ha versátil, *!/*/}
        {/*      /!*cosechó en partidos tengan jardineros, colaboración el de viva que sus de referencia *!/*/}
        {/*      /!*que despidos.*!/*/}
        {/*    </Typography>*/}
        {/*  </CardContent>*/}
        {/*</CardActionArea>*/}

        <CardActions className={classes.actions} disableActionSpacing>
          <Button
            aria-label="Add to favorites"
            variant="flat"
            size="small"
            className={classes.buttonDanger}
            component={Link}
            to={`/test/${test.id}/report`}
          >
            <WarningOutlined
              className={classNames(classes.leftIcon, classes.iconSmall)}
              style={{ color: "#FFCC33" }}
            />
            ¿Problemático?
          </Button>

          <Button
            aria-label="Duracion"
            variant="flat"
            size="small"
            className={classes.expand}
          >
            <AccessTimeOutlined
              className={classNames(classes.leftIcon, classes.iconSmall)}
            />
            Día inicio:
            {Array.isArray(project.medical_visits) &&
              project.medical_visits[0] && (
                <span>{project.medical_visits[0].date}</span>
              )}
          </Button>
          {/*<Button*/}
          {/*  aria-label="Retribucion"*/}
          {/*  variant="flat"*/}
          {/*  size="small"*/}
          {/*  className={classes.expand}*/}
          {/*>*/}
          {/*  <AccountBalanceWalletOutlined*/}
          {/*    className={classNames(classes.leftIcon, classes.iconSmall)}*/}
          {/*  />*/}
          {/*  45 &euro;*/}
          {/*</Button>*/}

          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={this.handleMenuClose}
          >
            <MenuItem
              onClick={this.handleMenuClose}
              component={Link}
              to={`/test/${test.id}/report/project/${test.project.id}`}
            >
              Informar de un problema
            </MenuItem>
            <MenuItem onClick={this.handleTestCancel}>
              Cancelar este Test
            </MenuItem>
          </Menu>
        </CardActions>
        {this.state.cancel && (
          <CancelTest
            open
            handleCancel={() => {
              this.setState({ cancel: false });
            }}
          />
        )}
      </Card>
    );
  }
}

TestItemOngoing.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TestItemOngoing);



// WEBPACK FOOTER //
// ./src/modules/test/components/TestItemOngoing.js